import ReactGA, { EventArgs, TrackerNames } from 'react-ga';
import debug from 'debug';

const log = debug('analytics:log');
const error = debug('analytics:error');

export function shouldTrack(): boolean {
  return process.env.NODE_ENV === 'production';
}

export function sendPageView(page: string, trackers?: TrackerNames): void {
  log('Send page view for %s', page);

  if (shouldTrack()) {
    try {
      ReactGA.set({ page });
      ReactGA.pageview(page, trackers);
    } catch (err) {
      error('Something went wrong sending page view', err);
    }
  }
}

export function sendEvent(eventData: EventArgs, trackerNames?: TrackerNames): void {
  const { category, action, label } = eventData;
  log('Trigger event for category "%s" and action "%s" with label "%s"', category, action, label);

  if (shouldTrack() && category && action) {
    try {
      ReactGA.event(eventData, trackerNames);
    } catch (err) {
      error('Something went wrong triggering event', err);
    }
  }
}
